import React from 'react';

function formatMoney(n, c, d, t) {
  var c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;

  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

function priceCalculator(price, quant, cart){
	let total = 0.00
	let totalprice = 0.00
	if (typeof cart != "undefined"){
		let Ncart = cart
		if (typeof Ncart != "undefined" && Ncart.hasOwnProperty("cartObjects")) {
			if(Ncart.cartObjects.length > 1){
				Ncart.cartObjects.map((obj, i) => 
					total += obj.price * obj.quanitity
				);	
				totalprice = total/100
			}else{
				totalprice = price/100 * quant
			}
		}
	}else{
		totalprice = price/100 * quant
	}
	return formatMoney(totalprice);
}

function getAccurateProducttotalsMessage(item, suggestedQuantityOption, kitQuantity1, kitQuantity2, kitQuantity3, kitQuantity4, kitQuantity5, kitQuantity6, kitQuantity7, kitQuantity8, cart, productID){
	if(cart.length == 0 && item.options.includes("Color")){
		
		return 'Select Prints to Move Forward';
	}else if (cart.length > 0){
		let messsage = cart.map((productCart, i) => {
			let finalCount = 0; 

			if (item.id == productCart.productID){
				productCart.cartObjects.map((variant,i) => {
					if(variant.quanitity > 0){
						finalCount += variant.quanitity
					}
				});
				
				if(productCart.cartObjects.length == 0 && !item.options.includes("Color")){
					return 'TOTAL: $' + priceCalculator(item.variants[0].price, suggestedQuantityOption, productCart);

				}else if(productCart.cartObjects.length == 1 && !item.options.includes("Color")){
					return 'TOTAL: $' + priceCalculator(item.variants[0].price, suggestedQuantityOption, productCart);

				}else if(finalCount > suggestedQuantityOption){
				
					return 'Remove Prints to Move Forward';
				   
				}else if(finalCount < suggestedQuantityOption && finalCount >= 0){
					
					return 'Select Prints to Move Forward';

				}else{
					return 'TOTAL: $' + priceCalculator(0,0,productCart);
				}
			}
		});
		return messsage;
	}else{

		let quantity = 1;
		if(suggestedQuantityOption == 0){
			quantity = kitQuantity1
		}else if(suggestedQuantityOption == 1){
			quantity = kitQuantity2
		}else if(suggestedQuantityOption == 2){
			quantity = kitQuantity3
		}else if(suggestedQuantityOption == 3){
			quantity = kitQuantity4
		}else if(suggestedQuantityOption == 4){
			quantity = kitQuantity5
		}else if(suggestedQuantityOption == 5){
			quantity = kitQuantity6
		}else if(suggestedQuantityOption == 6){
			quantity = kitQuantity7
		}else if(suggestedQuantityOption == 7){
			quantity = kitQuantity8
		}else{
			quantity = 1;
		}

		let finalCount = 0;
		item.variants.map((variant,i) => {
			if(variant.available){
				finalCount += 200
			}
		});	
		let num = 0	

		if(quantity == undefined || quantity == null){
			num = 0;
		}
		if(quantity < finalCount){
			if(finalCount >= 1){
				num = quantity
			}else{
				num = 1
			}
		}else if(finalCount == 0){
			num = 0
		}else if(quantity > finalCount){
			num = finalCount
		}else{
			num = 1
		}
		return 'TOTAL: $' + priceCalculator(item.variants[0].price, num);

	}

}

function getMaxQuantity(product, babySize){
	
	var color = product.options.includes("Color");
	let filteredProductVariants = [];

	if (product.variants.length > 0){
		product.variants.map((variant, i) => {	
			if (babySize !== undefined && variant.option1 !== null){
				if( variant.option1.toLowerCase() === babySize.toLowerCase() ){
					filteredProductVariants.push(variant);
				}
			}
			if (babySize !== undefined && variant.option2 !== null){
				if( variant.option2.toLowerCase() === babySize.toLowerCase() ){
					filteredProductVariants.push(variant);
				}
			}
			if (variant.option1 == "Default Title"){
				filteredProductVariants.push(variant);
			}
			if (variant.option1 != "Default Title"){
				filteredProductVariants.push(variant);
			}
		});
	}else{

	}

	let finalCount = 0;
	if (filteredProductVariants.length > 0){
		filteredProductVariants.map((variant,i) => {
			if(variant.available){
				finalCount += 200
			}
		});
	}
	
	return finalCount
}

function evaluateIfBelowMax(product, suggestedQuantityOption, kitQuantity1, kitQuantity2, kitQuantity3, kitQuantity4, kitQuantity5, kitQuantity6, kitQuantity7, kitQuantity8){
	let finalCount = 0;
	let kitQuantity = 1;
	if(suggestedQuantityOption == 0){
		kitQuantity = kitQuantity1
	}else if(suggestedQuantityOption == 1){
		kitQuantity = kitQuantity2
	}else if(suggestedQuantityOption == 2){
		kitQuantity = kitQuantity3
	}else if(suggestedQuantityOption == 3){
		kitQuantity = kitQuantity4
	}else if(suggestedQuantityOption == 4){
		kitQuantity = kitQuantity5
	}else if(suggestedQuantityOption == 5){
		kitQuantity = kitQuantity6
	}else if(suggestedQuantityOption == 6){
		kitQuantity = kitQuantity7
	}else if(suggestedQuantityOption == 7){
		kitQuantity = kitQuantity8
	}else{
		kitQuantity = 1;
	}

	product.variants.map((variant,i) => {
		if(variant.available){
			finalCount += 200
		}
	});

	if(kitQuantity == undefined || kitQuantity == null){
		kitQuantity = 1;
	}
	if(kitQuantity < finalCount){
		if(finalCount >= 1){
			return kitQuantity
		}else{
			return 1
		}
	}else if(finalCount == 0){
		return 0
	}else if(kitQuantity > finalCount){
		return finalCount
	}else{
		return 1
	}
}

function evalIfSoldOut(product){
	let availablity = 'none';

	if(product.title.includes("Wipe Up Wash") || product.title.includes("Washing Powder")){
		let available = product.variants[0].available;
		if(available){
			availablity = 'some';
		}
	}else{
		product.variants.map((variant,i) => {
			if(variant.available){
				availablity = 'some';
			}
		});
	}
	if(availablity == 'some'){
		return false;
	}else{
		return true;
	}
}

class ProductListing extends React.Component {

	constructor(props){
	    // Pass props to parent class
	    super(props);
	    // Set initial state
	    this.state = {
	      productQuantity: parseInt(evaluateIfBelowMax(this.props.item, this.props.suggestedQuantityOption, this.props.item.meta.kitSuggestedQuantity, this.props.item.meta.kitSuggestedQuantity2, this.props.item.meta.kitSuggestedQuantity3, this.props.item.meta.kitSuggestedQuantity4, this.props.item.meta.kitSuggestedQuantityPT, this.props.item.meta.kitSuggestedQuantity2PT, this.props.item.meta.kitSuggestedQuantity3PT, this.props.item.meta.kitSuggestedQuantity4PT)),
	      variantsSelected: false,
	      printsClass: false,
	      printsText: 'Select Prints',
	      totalprice: getAccurateProducttotalsMessage(this.props.item, this.props.suggestedQuantityOption, this.props.item.meta.kitSuggestedQuantity, this.props.item.meta.kitSuggestedQuantity2, this.props.item.meta.kitSuggestedQuantity3, this.props.item.meta.kitSuggestedQuantity4, this.props.item.meta.kitSuggestedQuantityPT, this.props.item.meta.kitSuggestedQuantity2PT, this.props.item.meta.kitSuggestedQuantity3PT, this.props.item.meta.kitSuggestedQuantity4PT, [], this.props.item.id),
	      productprice: this.props.item.variants[0].price/100,
	      lastCartObject: {},
	      kitShowOptionalFlag: this.props.item.meta.kitShowOptionalFlag,
	      maximumQuantity: parseInt(getMaxQuantity(this.props.item, this.props.babySize)),
	      soldOut: evalIfSoldOut(this.props.item)
	    }
 
	    this.increment 		= this.increment.bind(this);
	    this.printsStateMessage = this.printsStateMessage.bind(this);
 		this.decrement 		= this.decrement.bind(this);
 		this.focusOnQuantitySelector = this.focusOnQuantitySelector.bind(this);
 		this.updateQuantity = this.updateQuantity.bind(this);
 		this.renderImage	= this.renderImage.bind(this);
 		this.renderPrintsCTA = this.renderPrintsCTA.bind(this);
 		this.updateNonVariant = this.updateNonVariant.bind(this);
 		this.updateQuantityFromParent	= this.updateQuantityFromParent.bind(this);
 		this.updateQuantityInput = this.updateQuantityInput.bind(this);
 		this.openOverlay = this.openOverlay.bind(this);
 		this.incrementAccessibility = this.incrementAccessibility.bind(this);
 		this.decrementAccessibility = this.decrementAccessibility.bind(this);
	}

	updatePricing(price, quant, cart){
		
		var netprice = getAccurateProducttotalsMessage(this.props.item, quant, null, null, null, null, null, null, null, null, cart, this.props.item.id);
		this.setState({
			totalprice: netprice,
			productprice: price
	  	});
	}

	openOverlay(i, currQ, panel, e, maxQ, propsID){
		e.preventDefault();

		window.lastFocusedPropsID = propsID;
		if(e.which == 13 || e.keyCode == 13) {
	        this.props.openOverlay(i, currQ, panel, e, maxQ)
	    }
	}

	printsStateMessage(){
		let product = this.props.item.id
		let cart = [...this.props.cart]

		let message = cart.map((productCart) => {
			let finalCount = 0; 
			let myVar;
			productCart.cartObjects.map((variant,i) => {
				if(variant.quanitity > 0){
					finalCount += variant.quanitity
				}
			});
			if (product == productCart.productID){
				
				if(finalCount > this.state.productQuantity){
					clearTimeout(myVar);
					this.setState({
						printsClass: false,
						printsText: 'Remove Prints'
				    }, () => {
				  	});
				}else if(finalCount < this.state.productQuantity && finalCount >= 0){
					clearTimeout(myVar);
					this.setState({
						printsClass: false,
						printsText: 'Select Prints'
				    }, () => {
				  	});
				}else{
					clearTimeout(myVar);
					this.setState({
						printsClass: true
				    }, () => {
				  	});
				}
			}
		});

	}

	updateQuantityFromParent(quantity, cart){
		let cartObj = cart
		this.setState({
			productQuantity: quantity
		}, () => {
			this.printsStateMessage();
			this.setState({
				lastCartObject: cartObj,
				totalprice: getAccurateProducttotalsMessage(this.props.item, quantity, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
			});
			this.props.checkIfAllVariantsSelected();
		});
	}

	incrementAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.increment(e)
		}
	}

	decrementAccessibility(e){
		if(e.which == 13 || e.keyCode == 13) {
			this.decrement(e)
		}
	}

	increment(){
		if (this.props.item.variants.length > 1){
			if(this.state.productQuantity < this.state.maximumQuantity){
				var quantity = parseInt(this.state.productQuantity) + 1;
				this.setState({
					productQuantity: quantity,
					totalprice: getAccurateProducttotalsMessage(this.props.item, quantity, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
				}, () => {
					this.updateNonVariant();
					this.props.checkIfAllVariantsSelected();
					this.printsStateMessage();
				});
			}
		}else{
			if(this.state.productQuantity < this.state.maximumQuantity){
				var quantity = parseInt(this.state.productQuantity) + 1;
				this.setState({
					productQuantity: quantity,
					totalprice: getAccurateProducttotalsMessage(this.props.item, quantity, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
				}, () => {
					this.updateNonVariant();
					this.props.checkIfAllVariantsSelected();
					this.printsStateMessage();
				});
			}
		}
	}	

	decrement(){
		if (this.props.item.variants.length > 1){
			if( this.state.productQuantity > 0){
				var quantity = parseInt(this.state.productQuantity) - 1;
				this.setState({
					productQuantity: quantity,
					totalprice: getAccurateProducttotalsMessage(this.props.item, quantity, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
				}, () => {
					this.updateNonVariant();
					this.props.checkIfAllVariantsSelected();
					this.printsStateMessage();
				});
			}
		}else{
			if( this.state.productQuantity > 0){
				var quantity = parseInt(this.state.productQuantity) - 1;
				this.setState({
					productQuantity: quantity,
					totalprice: getAccurateProducttotalsMessage(this.props.item, quantity, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
				}, () => {
					this.updateNonVariant();
					this.props.checkIfAllVariantsSelected();
					this.printsStateMessage();
				});
			}
		}
	}

	focusOnQuantitySelector(e){
		let qFor = e.target.getAttribute('for');
		let qNAME = document.querySelector('[name="' + qFor + '"]');
		qNAME.focus();
	}

	updateNonVariant(){
		if ( this.props.item.variants.length <= 2 ){
			let cartObject = {
				'productID': this.props.item.id,
				'cartObject': [{
					id: this.props.item.variants[0].id,
					quanitity: this.state.productQuantity,
					price: this.props.item.variants[0].price
				}]
			}
			this.props.updateNonVariantOptionToCart(cartObject)
		}
	}

	updateQuantity(event){
		if (event.target.value === "" || event.target.value === null){
			this.setState({
				productQuantity: 0
			});
		} else {
			this.setState({
				productQuantity: event.target.value
			});
		}
		
	}

	updateQuantityInput(event){
		if (event.target.value === "" || event.target.value === null){
			this.setState({
				productQuantity: 0,
				totalprice: getAccurateProducttotalsMessage(this.props.item, 0, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
			});
		} else if (event.target.value > this.state.maximumQuantity){
			this.setState({
				productQuantity: this.state.maximumQuantity,
				totalprice: getAccurateProducttotalsMessage(this.props.item, event.target.value, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
			});
		}else{
			this.setState({
				productQuantity: event.target.value,
				totalprice: getAccurateProducttotalsMessage(this.props.item, event.target.value, null, null, null, null, null, null, null, null, this.props.cart, this.props.item.id)
			});
		}

		this.props.checkIfAllVariantsSelected();

		
	}


	renderImage(productTitle) {
		let imageUrl = this.props.item.meta.kitFeaturedImageOverride || 
					   this.props.item.meta.kitFeaturedImage || 
					   "https://cdn.shopify.com/s/files/1/2437/4465/t/1/assets/500x500_500x500.png";
	
		return (
			<div className="product-image">
				<img 
					src={"https:" + imageUrl} 
					alt={productTitle + " product image"} 
				/>
			</div>
		);
	}

	renderPrintsCTA(){
		var color = this.props.item.options.includes("Color");
		if ( color == true ){
			for (var prop in this.props.item.options) {
			  if (this.props.item.options[prop] == 'Color') {
			    return(
			    	<div className={(this.state.printsClass ? 'hide select-variants' : 'select-variants')} dangerouslySetInnerHTML={{__html: this.state.printsText}}></div>
			    )
			  }
			}
		}

	}

	componentDidMount(){
		this.updateNonVariant();
	}

	componentDidUpdate(oldProps) {
	  const newProps = this.props
	  if(oldProps.suggestedQuantityOption !== newProps.suggestedQuantityOption) {
	    this.setState({
	    	productQuantity: parseInt(evaluateIfBelowMax(this.props.item, this.props.suggestedQuantityOption, this.props.item.meta.kitSuggestedQuantity, this.props.item.meta.kitSuggestedQuantity2, this.props.item.meta.kitSuggestedQuantity3, this.props.item.meta.kitSuggestedQuantity4, this.props.item.meta.kitSuggestedQuantityPT, this.props.item.meta.kitSuggestedQuantity2PT, this.props.item.meta.kitSuggestedQuantity3PT, this.props.item.meta.kitSuggestedQuantity4PT)),
	    	totalprice: getAccurateProducttotalsMessage(this.props.item, this.props.suggestedQuantityOption, this.props.item.meta.kitSuggestedQuantity, this.props.item.meta.kitSuggestedQuantity2, this.props.item.meta.kitSuggestedQuantity3, this.props.item.meta.kitSuggestedQuantity4, this.props.item.meta.kitSuggestedQuantityPT, this.props.item.meta.kitSuggestedQuantity2PT, this.props.item.meta.kitSuggestedQuantity3PT, this.props.item.meta.kitSuggestedQuantity4PT, [], this.props.item.id)
	    })
	  }
	}

	render() {

		var returnPrintsCTA = this.renderPrintsCTA();
		var productTitle = () => {
			if(this.props.item.meta.kitTitle != ""){
				return this.props.item.meta.kitTitle;
			}else{
				return this.props.item.title;
			}
		}

    	return (
	    	<li key={this.props.item.id} className="grid item">
				<div role="group" aria-label="product">
					<button id={this.props.item.id} className="product-upper" 
						onClick={(e) => {this.props.openOverlay(this.props.item, this.state.productQuantity, this.props.panel, e, this.state.maximumQuantity, this.props.item.id)}} 
					>
						{ this.renderImage(productTitle()) }
						{ !this.state.soldOut &&
							<div>{ returnPrintsCTA }</div>
						}
						{ this.state.soldOut &&
							<div className="product__sold-out" aria-label="This product is out of stock.">Out of Stock</div>
						}
						{ this.state.kitShowOptionalFlag &&
							<div className="product__optional" aria-label="This product is optional.">Optional</div>
						}
					</button>
					<div className="product-lower">
						<h2 className="product__title">{productTitle()}</h2>
						<div className="product__quantity">
							<label class="quantity-label" htmlFor={"qid" + this.props.item.id} onClick={e => this.focusOnQuantitySelector(e)}>Quantity:</label>
							<button aria-label={"decrease" + productTitle() + " quantity by one"} className="quantity--increment" onClick={this.decrement} disabled={this.state.soldOut === true ? true : false}>-</button>
							<input aria-label={"text input: change the " + productTitle() + " quantity"} type="number" name={"qid" + this.props.item.id} id={this.props.item.id} className="quantity preview-tile-quant" value={(this.state.soldOut === true ? '0' : parseInt(this.state.productQuantity))} onChange={this.updateQuantityInput} disabled={this.state.soldOut === true ? true : false}></input>
							<button aria-label={"increase" + productTitle() + " quantity by one"} className="quantity--decrement" onClick={this.increment} disabled={this.state.soldOut === true ? true : false}>+</button>
						</div>
					</div>
					<div className="product__total">
						{ this.state.soldOut &&
						<span>Total: $0.00</span>
						}
						{ !this.state.soldOut &&  
						this.state.totalprice
						}
					</div>
				</div>
		  	</li>
		)
	}
};

export default ProductListing;